import { IoIosArrowDown, IoIosArrowUp, IoMdArrowUp, IoMdCreate, IoMdTrash } from "react-icons/io";
import {
  BottomContainer,
  CancelButton,
  Container,
  IconButton,
  SubmitButton,
  TopContainer,
} from "./styles";

export default function BaseSection({
  allowDelete,
  allowEdit,
  allowChangeOrder,
  isFirstItem,
  isLastItem,
  isEditting,
  customPadding,
  children,
  onToggleIsEditting = () => null,
  onCancelEditting = () => null,
  onSubmitEditting = () => null,
  onChangeOrderUp = () => null,
  onChangeOrderDown = () => null,
  onDelete = () => null
}) {
  const showTopContainer = (allowDelete || allowEdit) && !isEditting;
  const showBottomContainer = isEditting;

  return (
    <Container customPadding={customPadding}>
      {showTopContainer && (
        <TopContainer>
          {allowChangeOrder && (
            <>
              {!isFirstItem && (
                <IconButton title="Alterar ordem para cima" onClick={onChangeOrderUp}>
                  <IoIosArrowUp size="1.35em" />
                </IconButton>
              )}
              {!isLastItem && (
                <IconButton title="Alterar ordem para baixo" onClick={onChangeOrderDown}>
                  <IoIosArrowDown size="1.35em" />
                </IconButton>
              )}
            </>
          )}
          {allowEdit && (
            <IconButton onClick={onToggleIsEditting} title="Alterar o item">
              <IoMdCreate size="1.35em" />
            </IconButton>
          )}
          {allowDelete && (
            <IconButton onClick={onDelete} title="Remove o item. Essa ação é irreversível">
              <IoMdTrash size="1.35em" color="#B00020" />
            </IconButton>
          )}
        </TopContainer>
      )}
      {children}
      {showBottomContainer && (
        <BottomContainer>
          <CancelButton onClick={onCancelEditting}>Cancelar</CancelButton>
          <SubmitButton onClick={onSubmitEditting}>Salvar</SubmitButton>
        </BottomContainer>
      )}
    </Container>
  );
}
